import {
  SummaryStat,
  SummaryStatRow,
  SummaryStyled,
  SummaryTitle,
} from './Summary.styles';

interface Props {
  itemTotals: { title: string; value: number }[];
}

export const Summary = ({ itemTotals }: Props) => {
  return (
    <SummaryStyled>
      <SummaryTitle>Summary</SummaryTitle>
      {itemTotals.map((item) => {
        return (
          <SummaryStatRow key={item.title}>
            <SummaryStat>{item.title}</SummaryStat>
            <SummaryStat>{item.value}</SummaryStat>
          </SummaryStatRow>
        );
      })}
    </SummaryStyled>
  );
};
